import React from 'react';
import {
    Paper,
    Typography,
    Box,
    Button,
    CircularProgress,
} from '@mui/material';
import { CheckCircle as CheckCircleIcon } from '@mui/icons-material';

const OrderSummaryCard = ({
    order,
    onConfirm,
    confirming,
    onBack,
    confirmLabel = "Confirmar Pedido"
}) => {
    if (!order) return null;

    const subtotal = order.items?.reduce((sum, item) => sum + parseFloat(item.subtotal || 0), 0) || order.subtotal || 0;
    const total = order.items?.reduce((sum, item) => sum + parseFloat(item.subtotal || 0), 0) || order.total || 0;

    return (
        <Paper sx={{ p: 2.5, position: 'sticky', top: 24, border: '1px solid #d0dbe7', borderRadius: '0.75rem' }}>
            <Typography sx={{ fontWeight: 600, mb: 2, color: '#0e141b' }}>Resumen del Pedido</Typography>
            <Box sx={{ mb: 3 }}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                    <Typography sx={{ fontSize: '0.875rem', color: '#4e7397' }}>Items</Typography>
                    <Typography sx={{ fontWeight: 500 }}>{order.items?.length || 0}</Typography>
                </Box>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                    <Typography sx={{ fontSize: '0.875rem', color: '#4e7397' }}>Subtotal</Typography>
                    <Typography sx={{ fontWeight: 500 }}>${subtotal.toLocaleString('es-AR', { minimumFractionDigits: 2 })}</Typography>
                </Box>
                <Box sx={{ borderTop: '1px solid #e7edf3', pt: 1, mt: 1 }}>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <Typography sx={{ fontWeight: 600, fontSize: '1rem' }}>Total a Pagar</Typography>
                        <Typography sx={{ fontWeight: 700, fontSize: '1.5rem', color: '#1976d2' }}>
                            ${total.toLocaleString('es-AR', { minimumFractionDigits: 2 })}
                        </Typography>
                    </Box>
                </Box>
            </Box>

            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                <Button
                    fullWidth variant="contained"
                    startIcon={confirming ? <CircularProgress size={20} color="inherit" /> : <CheckCircleIcon />}
                    onClick={onConfirm}
                    disabled={confirming || !order.items?.length}
                    sx={{
                        bgcolor: '#1976d2',
                        py: 1.5, fontWeight: 600,
                        '&:hover': { bgcolor: '#1565c0' },
                    }}
                >
                    {confirming ? 'Confirmando...' : confirmLabel}
                </Button>
                {onBack && (
                    <Button fullWidth variant="outlined" onClick={onBack} sx={{ borderColor: '#e7edf3', color: '#0e141b' }}>
                        Volver / Editar
                    </Button>
                )}
            </Box>
            <Typography sx={{ fontSize: '0.75rem', color: '#4e7397', textAlign: 'center', mt: 2 }}>
                Al confirmar, el pedido pasará a la sala de elaboración.
            </Typography>
        </Paper>
    );
};

export default OrderSummaryCard;
